import { Command } from 'commander';
import { ConnectContextService } from '../../services/connect-context.service.js';
import { ConnectPolicyService } from '../../services/connect-policy.service.js';

interface PolicyOptions {
    json?: boolean;
}

export function createConnectPolicyCommand(): Command {
    return new Command('policy')
        .description('Show effective permission policy per environment/connection')
        .option('-j, --json', 'Output JSON')
        .action(function (this: Command, options: PolicyOptions) {
            const context = new ConnectContextService();
            const settings = context.getSettings();
            const policyService = new ConnectPolicyService(settings);
            const summaries = context.summarize();
            const useJson = !!(options.json || this.optsWithGlobals().json);

            const rows = summaries.flatMap((summary) =>
                summary.connections.map((connection) => {
                    const read = policyService.evaluate(summary.env, connection.runtime, 'read');
                    const write = policyService.evaluate(summary.env, connection.runtime, 'write');
                    const del = policyService.evaluate(summary.env, connection.runtime, 'delete');
                    const schema = policyService.evaluate(summary.env, connection.runtime, 'schema');
                    return {
                        env: summary.env,
                        connection: connection.name,
                        runtime: connection.runtime,
                        source: read.source,
                        allow: {
                            read: read.allowed,
                            write: write.allowed,
                            delete: del.allowed,
                            schema: schema.allowed,
                        },
                        requireConfirm: read.requireConfirm || write.requireConfirm || del.requireConfirm || schema.requireConfirm,
                        requireReason: read.requireReason || write.requireReason || del.requireReason || schema.requireReason,
                    };
                })
            );

            if (useJson) {
                console.log(JSON.stringify({ policy: rows }, null, 2));
                return;
            }

            if (rows.length === 0) {
                console.log('No connections found to evaluate policy.');
                return;
            }

            for (const row of rows) {
                const ops = [
                    row.allow.read ? 'read' : '',
                    row.allow.write ? 'write' : '',
                    row.allow.delete ? 'delete' : '',
                    row.allow.schema ? 'schema' : '',
                ].filter(Boolean).join(',');
                console.log(`${row.env.padEnd(12)} ${row.connection.padEnd(8)} allow=[${ops || 'none'}] source=${row.source}`);
            }
        });
}
